export default __webpack_public_path__ + "static/media/nodejs.502737ea.svg";